document.addEventListener( 'DOMContentLoaded', function ( e ) {
	document.querySelectorAll( 'a' ).forEach( function ( elem ) {
		// getAttribute returns null for <a> without href, which used to throw here and kill
		// the rest of this loop.
		if ( !elem.getAttribute( 'href' ) ) {
			return;
		}

		// Resolved protocol/hostname rather than raw-string matching: `//host/path` is an
		// external link, but startsWith('/') used to classify it as internal. Kept in step
		// with the same test in exit-notice.ts.
		if ( elem.protocol !== 'http:' && elem.protocol !== 'https:' ) {
			return;
		}

		if ( elem.hostname === window.location.hostname ) {
			return;
		}

		// featherlight is gone; media triggers now carry `noexitnotice` explicitly.
		if ( elem.classList.contains( 'noexitnotice' ) ) {
			return;
		}

		if ( elem.getAttribute( 'data-scrollto' ) || elem.classList.contains( 'scroll-to' ) ) {
			return;
		}

		if ( !elem.getAttribute( 'target' ) ) {
			elem.target = '_blank';
			// console.log( elem );
		}

	} );
} );
